import moment from 'moment'

export const data = () => ({
  isDebug: true,
  loading: false,
  toggle: false,
  selectedMarquee: null,
  selectedMarqueeAnnouncementID: 0,
  formatDateFn: function(value) {
    return value != null ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY') : ''
  },

  filters: {
    show: false
  },

  region: {},

  rows: [],

  columns: [
    {
      field: 'announcementHtml',
      label: 'Announcement',
      aria: 'Announcement',
      width: '70%',
      sortable: true,
      searchable: true
    },
    {
      field: 'publishDate',
      label: 'Published',
      date: true,
      width: '10%',
      sortable: true,
      searchable: true
    },
    {
      field: 'expirationDate',
      label: 'Expires',
      date: true,
      width: '10%',
      sortable: true,
      searchable: true
    }
  ],

  styles: {
    formRow: {
      padding: '10px',
      whiteSpace: 'nowrap'
    },
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
